(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/terms-integrity/assets/javascripts/views/cookies.js') >= 0) return;  svs.modules.push('/modules/terms-integrity/assets/javascripts/views/cookies.js'); 
(function(Backbone, svs) {
  'use strict';

  svs.terms_integrity.views.Cookies = Backbone.Marionette.View.extend({
    tagName: 'div',
    id: 'cookies',
    modelEvents: {
      change: 'render'
    },

    template: function(data) {
      return svs.terms_integrity.templates.cookies(data);
    },

    initialize: function() {
      svs.terms_integrity_logger.debug('svs.terms_integrity.views.Cookies - initialize');
    },

    onRender: function() {}
  });
})(Backbone, svs);

 })(window);